(() => {
  const stickyVariantOptions = Array.from(
    document.querySelectorAll('[data-sticky-variant-option]')
  );

  const syncStickyVariant = variant => {
    if (!variant) return;
    stickyVariantOptions.forEach(option => {
      const selected = option.value === String(variant.id);
      option.setAttribute('aria-pressed', String(selected));
      option.classList.toggle('is-selected', selected);
    });
  };

  if (stickyVariantOptions.length) {
    const primaryVariantSelect = document.querySelector('[data-variant-select]');

    if (primaryVariantSelect?.value) {
      syncStickyVariant({ id: primaryVariantSelect.value });
    }

    stickyVariantOptions.forEach(stickyVariantOption => {
      stickyVariantOption.addEventListener('click', () => {
        if (!stickyVariantOption.value || stickyVariantOption.disabled) return;

        let optionValues = [];
        try {
          optionValues = JSON.parse(stickyVariantOption.dataset.optionValues || '[]');
        } catch (error) {
          optionValues = [];
        }

        optionValues.forEach((optionValue, index) => {
          const optionGroups = Array.from(
            document.querySelectorAll(`[data-product-option="option${index + 1}"]`)
          ).filter(group => !group.closest('#sticky-add-to-cart'));
          const optionGroup = optionGroups[0];
          if (!optionGroup) return;

          const matchingButton = Array.from(
            optionGroup.querySelectorAll('[data-option-value]')
          ).find(button => button.dataset.optionValue === String(optionValue));

          if (matchingButton && !matchingButton.disabled) {
            matchingButton.click();
            return;
          }

          const matchingSelect = optionGroup.querySelector('select');
          if (matchingSelect) {
            matchingSelect.value = String(optionValue);
            matchingSelect.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });

        syncStickyVariant({ id: stickyVariantOption.value });
      });
    });

    document.addEventListener('product:variant-change', event => {
      syncStickyVariant(event.detail?.variant);
    });
  }

  const stickyAddButton = document.getElementById('sticky-add-to-cart-button');
  if (stickyAddButton) {
    const syncStickyButton = () => {
      const primaryAddButton = Array.from(
        document.querySelectorAll('.product-form__cart-submit')
      ).find(button => !button.hidden && window.getComputedStyle(button).display !== 'none');
      if (!primaryAddButton) return;

      const disabled = primaryAddButton.disabled ||
        primaryAddButton.getAttribute('aria-disabled') === 'true';
      stickyAddButton.textContent = primaryAddButton.textContent.trim();
      stickyAddButton.disabled = disabled;
      stickyAddButton.toggleAttribute('aria-disabled', disabled);
    };

    syncStickyButton();
    document.addEventListener('product:variant-change', syncStickyButton);

    stickyAddButton.addEventListener('click', event => {
      if (stickyAddButton.hasAttribute('form')) return;

      event.preventDefault();
      const primaryAddButton = Array.from(
        document.querySelectorAll(
          'form[data-product-form] [data-product-primary-action] button[data-add-to-cart]'
        )
      ).find(button => !button.hidden && window.getComputedStyle(button).display !== 'none');
      if (!primaryAddButton || primaryAddButton.disabled) return;

      primaryAddButton.click();
    });
  }

  const initializeCollectionDescriptionToggles = root => {
    const collectionDescriptionToggles = Array.from(
      root.querySelectorAll('[data-collection-description-toggle]')
    );

    collectionDescriptionToggles.forEach(toggle => {
      if (toggle.dataset.collectionDescriptionToggleInitialized === 'true') return;

      const panelId = toggle.getAttribute('aria-controls');
      const panel = panelId ? document.getElementById(panelId) : null;
      const label = toggle.querySelector('[data-collection-description-toggle-label]');

      if (!panel || !panel.hasAttribute('data-collection-description-panel')) return;

      const setExpanded = expanded => {
        toggle.setAttribute('aria-expanded', String(expanded));
        toggle.classList.toggle('expanded', expanded);
        panel.hidden = !expanded;

        if (label) {
          label.textContent = expanded
            ? toggle.dataset.hideLabel || 'Hide collection description'
            : toggle.dataset.showLabel || 'Show collection description';
        }
      };

      toggle.dataset.collectionDescriptionToggleInitialized = 'true';
      setExpanded(toggle.getAttribute('aria-expanded') === 'true');

      toggle.addEventListener('click', () => {
        setExpanded(toggle.getAttribute('aria-expanded') !== 'true');
      });
    });
  };

  initializeCollectionDescriptionToggles(document);
  document.addEventListener('shopify:section:load', event => {
    initializeCollectionDescriptionToggles(event.target);
  });
})();
